import { footerInfo } from "@/constants/home";
import styles from "./index.module.css";
import logo from "@/assets/images/footer-logo.svg";
import { statTrack } from "@/utils/mtstat";

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.left}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={logo.src} alt="美图设计室" width={234} height={73} />
        </div>
        <div className={styles.right}>
          {footerInfo.cols.map((col, idx) => (
            <div className={styles.col} key={`col_${idx}`}>
              <div className={styles.title}>{col.title}</div>
              <div className={styles.content}>
                {col.list.map((item, index) => (
                  <a
                    className={styles.item}
                    href={item.url}
                    target="_blank"
                    rel="noreferrer"
                    key={`link_${index}`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();

                      window.open(item.url);
                      
                      statTrack("bottom_nav_click", {
                        class: "mtsjs_web",
                        region: col.mtValue,
                        value: item.title,
                      });
                    }}
                  >
                    {item.title}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div
        className={styles.copyright}
        dangerouslySetInnerHTML={{
          __html: `© ${new Date().getFullYear()}${footerInfo.copyright}`,
        }}
      ></div>
    </footer>
  );
};

export default Footer;
